import type { DealFixedRateLoanData, DealFloatingRateLoanData, DealForwardData } from '@src/types/OTC';
import { getOtcDealSpreadDisplayValue } from '@src/utils/OTC/otcDealDisplayUtils';
import { InspectorNumberDisplay } from './InspectorNumberDisplay';

type DealWithSpread = DealForwardData | DealFixedRateLoanData | DealFloatingRateLoanData;

export const SpreadDisplay = ({ instrumentData }: { instrumentData: DealWithSpread }) => {
  const displayValue = getOtcDealSpreadDisplayValue(instrumentData);
  if (!displayValue) {
    return null;
  }
  return <InspectorNumberDisplay value={displayValue.value} currency={displayValue.currency} showDashIfEmpty={false} />;
};
